import { useState } from 'react'

const COLORS = {
  bg: '#fffdf7',
  text: '#0a2342',
  textMuted: '#7a8a9a',
  accent: '#d9ad2b',
  border: '#e0d8c8',
  surface: '#f5f0e8',
}

const FEATURES = [
  'Project & pipeline tracking',
  'Pitch Tracker',
  'Income & tax calculator',
  'Rate Calculator',
  'Templates library',
  'Portfolio builder (coming soon)',
]

async function startCheckout(userId, email) {
  const res = await fetch('/api/create-checkout-session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, email }),
  })
  const { url } = await res.json()
  if (url) window.location.href = url
}

export default function Paywall({ session, subscriptionStatus, onBrowse }) {
  const [loading, setLoading] = useState(false)
  const userId = session?.user?.id
  const email = session?.user?.email

  const isLapsed = subscriptionStatus === 'canceled' || subscriptionStatus === 'past_due'

  const headline = isLapsed
    ? 'Your access has ended.'
    : 'Your free trial has ended.'

  const handleCTA = async () => {
    setLoading(true)
    await startCheckout(userId, email)
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh', background: COLORS.bg, display: 'flex',
      flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '40px 24px', fontFamily: "'Nunito Sans', sans-serif",
    }}>
      {/* Logo */}
      <img
        src="/images/logo-dark.png"
        alt="Ravenwood"
        style={{ height: 64, marginBottom: 32 }}
        onError={e => { e.target.style.display = 'none' }}
      />

      {/* Card */}
      <div style={{
        background: '#fff', border: `1px solid ${COLORS.border}`,
        borderRadius: 4, padding: '40px 48px', maxWidth: 560, width: '100%',
        boxShadow: '0 4px 24px rgba(10,35,66,0.07)',
      }}>
        {/* Headline */}
        <div style={{
          fontSize: 26, color: COLORS.text, fontFamily: "'Cardo', serif",
          marginBottom: 10, letterSpacing: '0.02em',
        }}>
          {headline}
        </div>
        <div style={{ fontSize: 14, color: COLORS.textMuted, marginBottom: 28, lineHeight: 1.6 }}>
          Buy Writer OS once and own it forever — no subscriptions, no renewals.
        </div>

        {/* Feature grid */}
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 16px', marginBottom: 28,
        }}>
          {FEATURES.map(f => (
            <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: COLORS.text }}>
              <span style={{ color: COLORS.accent, fontSize: 14 }}>✓</span>
              {f}
            </div>
          ))}
        </div>

        {/* CTA button */}
        <button
          onClick={handleCTA}
          disabled={loading}
          style={{
            width: '100%', background: loading ? COLORS.border : COLORS.accent,
            color: COLORS.text, border: 'none', padding: '13px 0',
            fontSize: 13, letterSpacing: '0.12em', textTransform: 'uppercase',
            fontFamily: "'Open Sans', sans-serif", fontWeight: 700,
            cursor: loading ? 'default' : 'pointer', marginBottom: 16,
            transition: 'opacity 0.15s',
          }}
        >
          {loading ? 'Redirecting...' : 'Buy Writer OS'}
        </button>

        {/* Just browsing link */}
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={onBrowse}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 12, color: COLORS.textMuted, fontFamily: "'Nunito Sans', sans-serif",
              textDecoration: 'underline', padding: 0,
            }}
          >
            Just browsing? View your data in read-only mode →
          </button>
        </div>
      </div>
    </div>
  )
}
